var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.08633H45C45.7957 5.08633 46.5587 5.39581 47.1213 5.94667C47.6839 6.49753 48 7.24467 48 8.0237V34.7819V34.9496V37.2297C48 38.0087 47.6839 38.7558 47.1213 39.3067C46.5587 39.8576 45.7957 40.167 45 40.167H29.36C29.2686 40.1671 29.179 40.1916 29.1009 40.238C29.0227 40.2844 28.9591 40.3509 28.9168 40.4302C28.8746 40.5095 28.8553 40.5987 28.8612 40.6879C28.867 40.7772 28.8977 40.8632 28.95 40.9366L32.898 46.4589C33.003 46.6055 33.0649 46.7776 33.077 46.9563C33.089 47.135 33.0508 47.3135 32.9665 47.4724C32.8821 47.6313 32.7549 47.7645 32.5986 47.8576C32.4423 47.9506 32.2629 47.9999 32.08 48H15.92C15.7371 47.9999 15.5577 47.9506 15.4014 47.8576C15.2451 47.7645 15.1179 47.6313 15.0335 47.4724C14.9492 47.3135 14.911 47.135 14.923 46.9563C14.9351 46.7776 14.997 46.6055 15.102 46.4589L19.05 40.9366C19.1023 40.8632 19.133 40.7772 19.1388 40.6879C19.1447 40.5987 19.1254 40.5095 19.0832 40.4302C19.0409 40.3509 18.9773 40.2844 18.8991 40.238C18.821 40.1916 18.7314 40.1671 18.64 40.167H3C2.20435 40.167 1.44129 39.8576 0.87868 39.3067C0.31607 38.7558 0 38.0087 0 37.2297V34.9496V34.7819V8.0237C0 7.24467 0.31607 6.49753 0.87868 5.94667C1.44129 5.39581 2.20435 5.08633 3 5.08633Z",
    fill: "#4053AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6468 43.1483C30.8325 44.3595 29.8953 45.4515 28.6699 45.4515H19.33C18.1046 45.4515 17.1674 44.3595 17.3531 43.1483L18.1398 38.0175C18.2894 37.0414 19.1291 36.3206 20.1167 36.3206H27.8832C28.8707 36.3206 29.7105 37.0414 29.8601 38.0175L30.6468 43.1483Z",
    fill: "#D5DCFF",
    stroke: "#2F3037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 46.466H35.0007H12.9999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 46.466H35.0007",
    stroke: "#2F3037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99994 4.84076C4.99994 3.73619 5.89537 2.84076 6.99994 2.84076H40.9999C42.1045 2.84076 42.9999 3.73619 42.9999 4.84076V32.2915C42.9999 33.3961 42.1045 34.2915 40.9999 34.2915H6.99994C5.89537 34.2915 4.99994 33.3961 4.99994 32.2915V4.84076Z",
    fill: "white",
    stroke: "#2F3037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9015 20.1018C18.8423 21.9483 21.374 22.9719 24.0004 22.9719C26.6268 22.9719 29.1585 21.9483 31.0993 20.1018",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9015 20.1018C18.8423 21.9483 21.374 22.9719 24.0004 22.9719C26.6268 22.9719 29.1585 21.9483 31.0993 20.1018",
    stroke: "#2F3037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5004 10.0574V12.9272V10.0574Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5004 10.0574V12.9272",
    stroke: "#2F3037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5002 10.0574V12.9272V10.0574Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5002 10.0574V12.9272",
    stroke: "#2F3037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.eed375ef.svg";
export { ForwardRef as ReactComponent };